import Vue from 'vue'

import DateFilter from '@/plugins/filters/date'
import TimeFilter from '@/plugins/filters/time'
import CurrencyFilter from '@/plugins/filters/currency'
import NumberFilter from '@/plugins/filters/number'
import NumberSignFilter from '@/plugins/filters/numberSign'
import IbanFilter from '@/plugins/filters/iban'
import TruncateFilter from '@/plugins/filters/truncate'
import SearchHighlightFilter from '@/plugins/filters/searchHighlight'
import OptionNameFilter from '@/plugins/filters/optionName'
import CurrencySignFilter from '@/plugins/filters/currencySign'
import ProfileStatusFilter from '@/plugins/filters/profileStatus'
import CardDateFilter from '@/plugins/filters/cardDate'
import CardTypeFilter from '@/plugins/filters/cardType'
import CardShipmentType from '@/plugins/filters/cardShipmentType'
import NameOnCardFilter from '@/plugins/filters/nameOnCard'
import UrgencyLabelFilter from '@/plugins/filters/urgencyLabel'
import ChannelFilter from '@/plugins/filters/channel'
import PanFilter from '@/plugins/filters/pan'
import AccountNameFilter from '@/plugins/filters/accountName'
import CalendarTypeFilter from '@/plugins/filters/calendarType'
import PlaceholderFilter from '@/plugins/filters/placeholder'
import BooleanValueFilter from '@/plugins/filters/booleanValue'
import RecipientPlaceholderFilter from '@/plugins/filters/recipientPlaceholder'
import MaturityFilter from '@/plugins/filters/maturity'
import CapitalWordsFilter from '@/plugins/filters/capitalWords'
import ConstStringFilter from '@/plugins/filters/constString'

Vue.filter('date', DateFilter)
Vue.filter('time', TimeFilter)
Vue.filter('currency', CurrencyFilter)
Vue.filter('number', NumberFilter)
Vue.filter('numberSign', NumberSignFilter)
Vue.filter('iban', IbanFilter)
Vue.filter('truncate', TruncateFilter)
Vue.filter('searchHighlight', SearchHighlightFilter)
Vue.filter('optionName', OptionNameFilter)
Vue.filter('currencySign', CurrencySignFilter)
Vue.filter('profileStatus', ProfileStatusFilter)
Vue.filter('cardDate', CardDateFilter)
Vue.filter('cardType', CardTypeFilter)
Vue.filter('cardShipmentType', CardShipmentType)
Vue.filter('nameOnCard', NameOnCardFilter)
Vue.filter('urgencyLabel', UrgencyLabelFilter)
Vue.filter('channel', ChannelFilter)
Vue.filter('pan', PanFilter)
Vue.filter('accountName', AccountNameFilter)
Vue.filter('calendarType', CalendarTypeFilter)
Vue.filter('placeholder', PlaceholderFilter)
Vue.filter('booleanValue', BooleanValueFilter)
Vue.filter('recipientPlaceholder', RecipientPlaceholderFilter)
Vue.filter('maturity', MaturityFilter)
Vue.filter('capitalWords', CapitalWordsFilter)
Vue.filter('constString', ConstStringFilter)
